export default __webpack_public_path__ + "static/media/calendar.f794e6b9.svg";